//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import AppCardCode from '@/@core/components/app-card-code/AppCardCode.vue'

import DemoLeafletBasic from './demos/DemoLeafletBasic.vue'
import DemoLeafletMarkerCirclePolygon from './demos/DemoLeafletMarkerCirclePolygon.vue'
import DemoLeafletPopup from './demos/DemoLeafletPopup.vue'
import DemoLeafletGeoJSON from './demos/DemoLeafletGeoJSON.vue'
import DemoLeafletLayerGroup from './demos/DemoLeafletLayerGroup.vue'
import DemoLeafletCustomIcon from './demos/DemoLeafletCustomIcon.vue'

import {
  leafletBasic,
  leafletMarkerCirclePolygon,
  leafletPopup,
  leafletGeoJSON,
  leafletLayerGroup,
  leafletCustomIcon,
} from './demos/code'

export default {
  components: {
    AppCardCode,
    DemoLeafletBasic,
    DemoLeafletMarkerCirclePolygon,
    DemoLeafletPopup,
    DemoLeafletGeoJSON,
    DemoLeafletLayerGroup,
    DemoLeafletCustomIcon,
  },
  setup() {
    return {
      codeSnippets: {
        leafletBasic,
        leafletMarkerCirclePolygon,
        leafletPopup,
        leafletGeoJSON,
        leafletLayerGroup,
        leafletCustomIcon,
      },
    }
  },
}
